import { Component, h, Host, Prop } from "@stencil/core";
import getSuggestionHighlight from "./get-suggestion-highlight";

@Component({
    tag: "ux-autosuggest-item",
    styleUrl: "autosuggest-item.scss",
    shadow: false
})
export class AutosuggestItem {
    /** search query that will be highlighted in the text */
    @Prop() readonly input?: string = "";
    /** suggestion text that matches the input */
    @Prop() readonly text?: string = "";
    /** subline below the text */
    @Prop() readonly subline?: string = "";
    /** optional image URL */
    @Prop() readonly image?: string = "";
    /** if set, the suggestion item will be slim, without a subline */
    @Prop() readonly slim: boolean = false;

    render() {
        const baseClass = "ux-autosuggest-item";
        const { text, subline, image, input } = this;
        // @ts-expect-error Check for typing
        const [highlight, remaining] = getSuggestionHighlight(input, text);
        return (
            <Host
                class={{
                    [baseClass]: true,
                    [`${baseClass}--slim`]: this.slim
                }}
            >
                {image !== "" && <div class={`${baseClass}__image`} style={{ backgroundImage: `url(${image})` }} />}
                <div
                    class={{
                        [`${baseClass}__text-container`]: true,
                        [`${baseClass}__text-container--slim`]: this.slim
                    }}
                >
                    <div class={`${baseClass}__text`}>
                        <span class={`${baseClass}__highlight`}>{highlight}</span>
                        {remaining}
                    </div>
                    {!this.slim && <div class={`${baseClass}__subline ux-text-tiny ux-text-tiny--bold`}>{subline}</div>}
                </div>
            </Host>
        );
    }
}
